import { legalDocument } from "@commerce/legal/documents";
import { LegalPage } from "@commerce/legal/LegalPage";
import { config } from "@repo/config";
import { createFileRoute, notFound } from "@tanstack/react-router";

/** Public legal pages: /legal/privacy, /legal/terms, /legal/dpa, /legal/subprocessors. */
export const Route = createFileRoute("/legal/$slug")({
	loader: ({ params }) => {
		const document = legalDocument(params.slug);
		if (!document) {
			throw notFound();
		}
		return document;
	},
	head: ({ loaderData }) => ({
		meta: loaderData
			? [
					{ title: `${loaderData.title} · ${config.appName}` },
					{ name: "description", content: loaderData.summary },
					{
						name: "robots",
						content: loaderData.draft
							? "noindex, nofollow"
							: "index, follow",
					},
				]
			: [],
	}),
	component: LegalRoute,
});

function LegalRoute() {
	return <LegalPage document={Route.useLoaderData()} />;
}
